import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { rootUrl, formatToZMW } from '../../helpers'
import { FaBoxOpen, FaPlus, FaTrash, FaWallet, FaBuilding, FaList, FaDollarSign, FaSpinner } from 'react-icons/fa'
import { useAuth } from '../../context/auth-context'
import Select from "react-select";
export default function Opening() {


    const [coa, setCoa] = useState([])
    const [open, setOpen] = useState([])
    const [bank, setBank] = useState([])
const [mod, setMod] = useState({ open: false, title: '', message: '', onConfirm: null })

const handleModClose = () =>{
  setMod({ ...mod, open: false });
}
    const auth = useAuth()

        const fetchData = async () =>{
                try{

                    const data = await axios.get(rootUrl(`/getOpen/${auth.user.id}`))
                    
                    setCoa(data.data.coa)
                    setOpen(data.data.open)
                    setBank(data.data.bank)

                }catch(e){
                    toast.error(e?.message)
                }
        }

        useEffect(()=>{
            fetchData()
        },[])

        const [modalOpen, setModalOpen] = useState(false);

        const handleSubmit = async (data) => {

            data['cid'] = auth.user.cid
            data['year'] = 2025;
            data['uid'] = auth.user.id.toString();


          const resp = await axios.post(rootUrl(`/postOpen`), data)

          if(resp.data.status == 200){
            toast.success("Successful")
          }else{
            toast.error("Something went wrong")
          }
          
        };
        
        const delOpening  = async (bid)=>{

        setMod({
          open: true,
          title: 'Warning',
          message: 'Are you sure you want to delete this items?',
          onConfirm: async () => {
            try{
              const resp = await axios.get(rootUrl(`/delOpening/${bid}`))
              handleModClose()
              fetchData()
              
          }catch(e){
              toast.error(e?.message)
          }
          }
        })
       
          
          

        }

  return (
    <div className="space-y-6">

      {/* Header */}
      <div className="bg-gradient-to-r from-blue-950 to-blue-800 rounded-2xl p-6 text-white shadow-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="bg-white/20 rounded-xl p-3">
              <FaBoxOpen className="text-2xl" />
            </div>
            <div>
              <h1 className="text-2xl md:text-3xl font-bold">Opening Balances</h1>
              <p className="text-blue-100 text-sm mt-1">Manage initial account balances</p>
            </div>
          </div>
          <button 
            onClick={() => setModalOpen(true)} 
            className="flex items-center gap-2 px-4 py-2.5 bg-white text-blue-950 rounded-lg hover:bg-blue-50 transition-colors font-medium shadow-sm"
          >
            <FaPlus />
            <span>Add Opening Balance</span>
          </button>
        </div>
      </div>

      {/* Modal - Always Available */}
      <AddItemModal isOpen={modalOpen} onClose={() => setModalOpen(false)} onSubmit={handleSubmit} coa={coa} bank={bank} />

      {/* Opening Balances Table */}
      {open && open.length > 0 ? (
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gradient-to-r from-blue-950 to-blue-800 text-white">
                    <th className="px-6 py-4 text-left font-semibold text-sm">
                      <div className="flex items-center gap-2">
                        <FaList className="text-sm" />
                        <span>S.No</span>
                      </div>
                    </th>
                    <th className="px-6 py-4 text-left font-semibold text-sm">
                      <div className="flex items-center gap-2">
                        <FaWallet className="text-sm" />
                        <span>Account</span>
                      </div>
                    </th>
                    <th className="px-6 py-4 text-right font-semibold text-sm">
                      <div className="flex items-center justify-end gap-2">
                        <FaDollarSign className="text-sm" />
                        <span>Amount</span>
                      </div>
                    </th>
                    <th className="px-6 py-4 text-center font-semibold text-sm">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {open.map((item, index) => (
                    <tr key={index} className="border-b border-gray-200 hover:bg-gray-50 transition-colors">
                      <td className="px-6 py-4 text-gray-700">{index + 1}</td>
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-2">
                          {item.type == 'COA' ? (
                            <>
                              <FaBuilding className="text-blue-500 text-sm" />
                              <span className="text-gray-900 font-medium">
                                {coa.find(a=>a.account === item.fkey)?.account || item.fkey}
                              </span>
                            </>
                          ) : (
                            <>
                              <FaWallet className="text-green-500 text-sm" />
                              <span className="text-gray-900 font-medium">
                                {bank.find(a=>a.id === item.fkey)?.name || 'Bank'}
                              </span>
                            </>
                          )}
                        </div>
                      </td>
                      <td className="px-6 py-4 text-right text-gray-900 font-medium">
                        {formatToZMW(item.amount)}
                      </td>
                      <td className="px-6 py-4 text-center">
                        <button
                          onClick={()=>delOpening(item.fkey)}
                          className="p-2 bg-red-100 hover:bg-red-200 text-red-700 rounded-lg transition-colors"
                          title="Delete opening balance"
                        >
                          <FaTrash className="text-sm" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
      ) : (
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-12 text-center">
          <FaBoxOpen className="text-gray-400 text-5xl mx-auto mb-4" />
          <p className="text-gray-600 font-medium text-lg mb-2">No Opening Balances</p>
          <p className="text-gray-500 text-sm mb-6">Get started by adding your first opening balance</p>
          <button 
            onClick={() => setModalOpen(true)} 
            className="inline-flex items-center gap-2 px-4 py-2.5 bg-blue-950 text-white rounded-lg hover:bg-blue-900 transition-colors font-medium"
          >
            <FaPlus />
            <span>Add Opening Balance</span>
          </button>
        </div>
      )}

      {/* Custom Delete Confirmation Modal */}
      {mod.open && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
            {/* Header */}
            <div className="bg-gradient-to-r from-red-600 to-red-700 rounded-t-2xl p-6 text-white">
              <div className="flex items-center gap-3">
                <div className="bg-white/20 rounded-lg p-2">
                  <FaTrash className="text-xl" />
                </div>
                <div>
                  <h2 className="text-xl font-bold">{mod.title}</h2>
                  <p className="text-red-100 text-sm mt-0.5">This action cannot be undone</p>
                </div>
              </div>
            </div>

            {/* Body */}
            <div className="p-6">
              <div className="flex items-start gap-4">
                <div className="bg-red-100 rounded-lg p-2 flex-shrink-0">
                  <FaTrash className="text-red-600 text-lg" />
                </div>
                <div className="flex-1">
                  <p className="text-gray-700 font-medium mb-2">{mod.message}</p>
                  <p className="text-sm text-gray-500">Please confirm if you want to proceed with this action.</p>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="flex justify-end gap-3 px-6 py-4 border-t border-gray-200 bg-gray-50 rounded-b-2xl">
              <button
                onClick={handleModClose}
                className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  if (mod.onConfirm) {
                    mod.onConfirm();
                  }
                }}
                className="px-4 py-2 bg-gradient-to-r from-red-600 to-red-700 text-white rounded-lg hover:shadow-lg transition-all font-medium flex items-center gap-2"
              >
                <FaTrash className="text-sm" />
                <span>Delete</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}


const AddItemModal = ({ isOpen, onClose, onSubmit, coa, bank  }) => {
  const [formData, setFormData] = useState({
    amount: "",
    type: "",
    fkey: "",
  });

  const typeOptions = ["Cashbook", "COA"]; 

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const isEmpty = Object.values(formData).some(value => !value);
    if(isEmpty){
        toast.error("Ensure all fields are filled")
        return
    }
    onSubmit(formData); 
    onClose(); 
  };

  const fkeyOptions = coa
  .filter((a) => !["1", "2", "3"].includes(a.account[0]))
  .map((fkey) => ({
    value: fkey.account,
    label: fkey.account,
  }));

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-950 to-blue-800 rounded-t-2xl p-6 text-white">
          <div className="flex items-center gap-3">
            <div className="bg-white/20 rounded-lg p-2">
              <FaPlus className="text-xl" />
            </div>
            <div>
              <h2 className="text-xl font-bold">Add Opening Balance</h2>
              <p className="text-blue-100 text-sm mt-0.5">Enter account opening balance details</p>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          {/* Amount Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <div className="flex items-center gap-2">
                <FaDollarSign className="text-gray-500" />
                <span>Amount</span>
              </div>
            </label>
            <input
              type="text"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
              placeholder="Enter amount"
              required
            />
          </div>

          {/* Type Dropdown */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <div className="flex items-center gap-2">
                <FaList className="text-gray-500" />
                <span>Type</span>
              </div>
            </label>
            <select
              name="type"
              value={formData.type}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
              required
            >
              <option value="">Select Type</option>
              {typeOptions.map((type, index) => (
                <option key={index} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>



          {formData.type === "COA" ? (
            <>
              {/* COA Dropdown */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <div className="flex items-center gap-2">
                    <FaBuilding className="text-gray-500" />
                    <span>Chart of Account</span>
                  </div>
                </label>
                <select
                  name="fkey"
                  value={formData.fkey}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  required
                >
                  <option value="">Select COA</option>
                  {coa
                    .filter((a) => !["1", "2"].includes(a.account[0]))
                    .map((fkey, index) => (
                      <option key={index} value={fkey.account}>
                        {fkey.account} - {fkey.name}
                      </option>
                    ))}
                </select>
              </div>
            </>
          ) : (
            <>
              {/* Bank Dropdown */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <div className="flex items-center gap-2">
                    <FaWallet className="text-gray-500" />
                    <span>Cashbook</span>
                  </div>
                </label>
                <select
                  name="fkey"
                  value={formData.fkey}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  required
                >
                  <option value="">Select Cashbook</option>
                  {bank.map((fkey, index) => (
                    <option key={index} value={fkey.id}>
                      {fkey.name}
                    </option>
                  ))}
                </select>
              </div>
            </>
          )}

          {/* Buttons */}
          <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
            <button
              type="button"
              className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
              onClick={onClose}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="px-6 py-2.5 bg-gradient-to-r from-blue-950 to-blue-800 text-white rounded-lg hover:shadow-lg transition-all font-medium flex items-center gap-2"
            >
              <FaPlus />
              <span>Add Balance</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};


